'use client';

import CreateSession from '@/components/CreateSession';

const CreateSessionPage = () => (
  <CreateSession />
);

export default CreateSessionPage;
